module.exports = __webpack_public_path__ + "img/9f351cf.png";